// test356
(356 && 0);
